import axios from 'utils/axios';

export async function fetchTwilioAccessToken() {
    try {
        const response = await axios.post('/api/org-id/{orgId}/clinic-id/{clinicId}/twilio/access-token');
        return response;
    } catch (e) {
        if (e && e.statusCode && e.message) {
            throw e;
        }
        throw new Error('unknown error');
    }
}
